import React from "react";
import Select from "react-select";

const SelectFieldMultiple = ({
  id,
  label,
  name,
  customClass,
  value,
  onChange,
  error,
  touch,
  options,
}) => {
  // Convert options to the format required by react-select
  const selectOptions = options?.data?.map((data) => ({
    value: data.name,
    label: data.name,
  }));

  // Convert the selected values to the format required by react-select
  const selectedValues = value?.map((val) => ({
    value: val,
    label: val,
  }));

  // Handle change event
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    onChange({
      target: {
        name: name,
        value: selectedValues,
      },
    });
  };


  return (
    <div className={`mt-2 ${customClass}`}>
      <label
        htmlFor={id}
        className="block text-sm capitalize font-medium text-gray-900"
      >
        {label}
      </label>
      <Select
        id={id}
        name={name}
        value={selectedValues}
        onChange={handleChange}
        options={selectOptions}
        isMulti
        className="mt-1"
        classNamePrefix="select"
        placeholder="Select options..."
      />
      {error && touch ? (
        <h1 className="text-xs text-red-600 mt-1">{error}</h1>
      ) : null}
    </div>
  );
};

export default SelectFieldMultiple;
